var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9868 31.3618C54.9868 44.4095 44.4095 54.9868 31.3618 54.9868C18.3141 54.9868 7.73682 44.4095 7.73682 31.3618C7.73682 18.3141 18.3141 7.73682 31.3618 7.73682C44.4095 7.73682 54.9868 18.3141 54.9868 31.3618ZM33.1579 41.4473C33.1579 42.363 32.4156 43.1052 31.5 43.1052C30.5843 43.1052 29.8421 42.363 29.8421 41.4473C29.8421 40.5317 30.5843 39.7894 31.5 39.7894C32.4156 39.7894 33.1579 40.5317 33.1579 41.4473ZM31.5 18.8947C28.2008 18.8947 25.5263 21.5692 25.5263 24.8684V25.2H27.5263V24.8684C27.5263 22.6738 29.3054 20.8947 31.5 20.8947C33.6946 20.8947 35.4737 22.6738 35.4737 24.8684V26.0975C35.4737 27.2567 34.7441 28.2905 33.6518 28.6788C31.7622 29.3507 30.5 31.1391 30.5 33.1446V37.5789H32.5V33.1446C32.5 31.9854 33.2296 30.9516 34.3218 30.5632C36.2114 29.8914 37.4737 28.103 37.4737 26.0975V24.8684C37.4737 21.5692 34.7991 18.8947 31.5 18.8947Z",
    fill: "#05073C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionFill);
export default __webpack_public_path__ + "static/media/question-fill.37f9c770b26cc362b5cc0c2754030d7b.svg";
export { ForwardRef as ReactComponent };